/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    h3: "h3",
    ol: "ol",
    li: "li",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: ["The Section component is a visual helper. It wraps content inside a visual section banner. Under the hood it uses a couple of tricks to get an infinite wide look background. You don't need to do anything more than you else would do regarding your content and the ", _jsx(_components.code, {
        children: "max-width"
      }), ". The background from the Section component will go beyond a ", _jsx(_components.code, {
        children: "max-width"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "Usage"
    }), "\n", _jsxs(_components.p, {
      children: ["The following example shows form sections with different styling. The helper prop ", _jsx(_components.code, {
        children: "spacing"
      }), " adds spacing to the section if needed."]
    }), "\n", _jsx(_components.h2, {
      children: "Customize color"
    }), "\n", _jsxs(_components.p, {
      children: ["Example of how to change the background color and by using a custom color. Yes, we use the ", _jsx(_components.code, {
        children: "color"
      }), " property for that."]
    }), "\n", _jsx(_components.h3, {
      children: "Define a custom Section color"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Create a custom CSS style declaration"
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-css",
        children: ".dnb-section--custom-section::after {\n  color: var(--color-ocean-green);\n}\n"
      })
    }), "\n", _jsxs(_components.ol, {
      start: "2",
      children: ["\n", _jsx(_components.li, {
        children: "and use that custom CSS class"
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "<Section style_type=\"custom-section\">...</Section>\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Custom Section color in plain HTML"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Create a custom CSS style declaration"
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-css",
        children: ".custom-section::after {\n  color: var(--color-ocean-green);\n}\n"
      })
    }), "\n", _jsxs(_components.ol, {
      start: "2",
      children: ["\n", _jsx(_components.li, {
        children: "and use that custom CSS class"
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-html",
        children: "<div className=\"dnb-section custom-section\">...</div>\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
